import { Platform, type ViewProps } from 'react-native';

/**
 * RN Web: bundled `accessibilityLabel` on a `View` is unreliable when children are plain `Text`
 * (VoiceOver/Safari often skip the block). Mirror the pattern from `webFocusableSectionTextProps`
 * (workspaces/frontend) so the DOM gets a real region + `aria-label` + tab stop.
 */
export function productSummaryRegionWebProps(label: string): Partial<ViewProps> | undefined {
  if (Platform.OS !== 'web') {
    return undefined;
  }
  return {
    role: 'region',
    'aria-label': label,
    tabIndex: 0,
  } as Partial<ViewProps>;
}
